const { link: socialMedia } = require("./socialMedia");
const twitter = require("./twitter");

const url = {
  domain: "https://www.uncookd.com",
  favicon: "https://www.uncookd.com/favicon2.ico",
  status: "https://status.uncookd.com",
  buyMeACoffee: socialMedia.buyMeACoffee("uncookd"),
  github: "https://github.com/nameer-rizvi/uncookd-react",
  instagram: socialMedia.instagram("uncookd_official"),
  koFi: socialMedia.koFi("uncookd"),
  patreon: socialMedia.patreon("uncookd"),
  reddit: "https://www.reddit.com/r/uncookd",
  twitter: socialMedia.twitter(twitter.username),
};

module.exports = url;

// Not ready for public consumption...
//
// facebook: socialMedia.facebook("Uncookd-267513444141898"),
// medium: socialMedia.medium("@uncookd"),
// tumblr: socialMedia.tumblr("uncookd"),
// youtube: socialMedia.youtube("UC7eMg-SvAXvVaR91GQ2h91A"),
